import React, {useMemo} from "react";
import {loadStripe} from "@stripe/stripe-js";
import {Elements} from "@stripe/react-stripe-js";

const ElementsWrapper = ({ stripePublicKey, stripeAccountId, children }) => {
    const stripePromise = useMemo(() => loadStripe(stripePublicKey, {
        stripeAccount: stripeAccountId
    }), [stripePublicKey]);

    return (
        <Elements stripe={stripePromise}>
            {children}
        </Elements>
    );
};

export default ElementsWrapper;